import { Grid } from "@mui/material";
import React, { useEffect } from "react";

const GridDataDetails = ({
  title,
  data,
  marginLeft,
  mdt,
  mdc,
  mdd,
  ...others
}) => {
  useEffect(() => {
    const elements = document.querySelectorAll(".data-inside-content");
    let maxWidth = 0;

    elements.forEach((el) => {
      const width = el.getBoundingClientRect().width;
      if (width > maxWidth) {
        maxWidth = width;
      }
    });

    elements.forEach((el) => {
      el.style.width = `${maxWidth}px`;
    });
  }, []);

  return (
    <div>
      <Grid
        container
        style={{
          // marginLeft: marginLeft ? marginLeft : "2.8rem",
          marginTop: "0.2rem",
          width: "100%",
        }}
      >
        {title && <Grid
          item
          // md={mdt ? mdt : 1.6}
          // sx={{ width: "100%" }}
          // sm={4}
          // xs={4}
          // className="no_width"
          sx={{
            width: "fit-content", // Adjust width based on content
            display: "inline-block", // Ensures it doesn't stretch unnecessarily
            padding: 0, // Optional: Removes additional padding from Grid
            whiteSpace: "nowrap",
          }}
          className="data-inside-content"
        >
          <span
            style={{
              fontSize: ".875rem",
              // fontSize: "0.92vw",
              fontWeight: "400",
              color: "#2C2A2A",
              marginLeft: "1%",
            }}
          >
            {title}
          </span>
        </Grid>}
        {title && <Grid
          item
          // md={mdc ? mdc : 0.16}
          sx={{ width: "fit-content", padding: "0 0.5rem" }}
        // sm={1}
        // xs={1}
        // className="semiColon"
        >
          <span className="label-sm" style={{ fontWeight: "400" }}>
            :
          </span>
        </Grid>}
        <Grid
          item
          // md={mdd ? mdd : 9.24}
          sx={{ flex: 1 }}
          // sm={5}
          // xs={5}
          className="no_width"
        >
          <div style={{ textAlign: "justify" }}>
            <span
              style={{
                fontSize: ".875rem ",
                // fontSize: "0.8vw",
                fontWeight: "400",
                color: "#2C2A2A",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
            // className="data-inside-content"
            >
              {data}
            </span>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default GridDataDetails;
